// extracted by mini-css-extract-plugin
export default {"headingTitle":"MediaLibraryPopup_headingTitle__yvyIL","actionButtons":"MediaLibraryPopup_actionButtons__r4f5-","addOption":"MediaLibraryPopup_addOption__yiwsn"};